import $ from 'jquery'
import 'jquery.marquee'

const bodyWidth = $('body').outerWidth()
const marqueeDOM = $('.pt-home__header--slogan')
marqueeDOM.css('width', bodyWidth)

marqueeDOM.marquee({
  duration: 30000,
  gap: 30,
  delayBeforeStart: 0,
  direction: 'left',
  duplicated: true,
  pauseOnHover: true,
  startVisible: true,
})
